module.exports = "<!-- countdownTimer.template.html -->\n<div class=\"countdownTimer\"></div>"